import classNames from 'classnames';
import React from 'react';
import { HasClassName } from '../component-utils';
import './FormLabel.scss';

export interface FormLabelProps extends HasClassName {
  label: NonNullable<React.PropsWithChildren<{}>['children']>
}

export default function FormLabel({ className, label, children }: React.PropsWithChildren<FormLabelProps>) {
  return <label className={classNames('FormLabel', className)}>
    <div className='label'>{label}</div>
    {children}
  </label>
}
